module.exports = __webpack_public_path__ + "img/section12.a19a74ac.png";